<template>
	<nav class="buzz-navbar">
		<div class="buzz-navbar-container">
			<div class="buzz-navbar-left">
				<button class="buzz-burger" :class="{ open: sidenavOpen }" @click="emit('toggle-sidenav')"
					aria-label="Toggle sidebar">
					<span></span>
					<span></span>
					<span></span>
				</button>
				<a class="buzz-title">{{ businessName }}</a>
			</div>
			<ul class="buzz-nav-list">
				<li class="buzz-nav-item" v-if="role === 'admin'">
					<router-link to="/admin/config/merchant" class="buzz-settings-link">
						<i class="fas fa-cog mr-2"></i>
						<span>Settings</span>
					</router-link>
				</li>
				<!-- <li class="buzz-nav-item">
						<a href="#" title="Notifications" class="buzz-bell-link">
							<i class="fas fa-bell mr-2"></i>
							<span>Notifications</span>
						</a>
					</li> -->
				<li class="buzz-nav-item">
					<a href="#" class="buzz-logout-link" @click.prevent="logout">
						<i class="fas fa-sign-out-alt mr-2"></i>
						<span>Logout</span>
					</a>
				</li>
			</ul>
		</div>
	</nav>
</template>
<script setup>
import { defineProps, ref, onMounted, defineEmits } from 'vue'
import http from '@/lib/http'
import { useSessionStore } from '@/stores/session'
import { useRouter } from 'vue-router'

defineProps({ sidenavOpen: Boolean, role: { type: String, required: true } })
const emit = defineEmits(['toggle-sidenav'])
const session = useSessionStore()
const router = useRouter()

onMounted(() => {
	getTitle();
})

const businessName = ref('');

async function getTitle() {
	try {
		const res = await http.get('/business/')
		const data = res && res.data ? res.data : null
		if (data && data.business && data.business.company) {
			businessName.value = data.business.company
			return
		}
	} catch (err) {
		console.warn('Failed to load business title', err)
	}

	businessName.value = ''
}

function logout() {
	session.clear();
	router.push({ name: 'login' });
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@700&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Rubik:wght@400;700&display=swap');

.buzz-navbar {
	background: #fff;
	border-bottom: 1.5px solid #e8edf4;
	box-shadow: 0 2px 10px rgba(36, 54, 84, 0.07);
	min-height: 56px;
	display: flex;
	align-items: center;
	padding: 0 36px;
}

.buzz-navbar-container {
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: space-between;
}

.buzz-navbar-left {
	display: flex;
	align-items: center;
	gap: 8px;
}

.buzz-burger {
	background: none;
	border: none;
	outline: none;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	width: 36px;
	height: 36px;
	margin-right: 0;
	cursor: pointer;
	padding: 0;
}

.buzz-burger {
	position: relative;
	z-index: 120;
}

.buzz-burger span {
	display: block;
	width: 24px;
	height: 3px;
	background: #243654;
	margin: 3px 0;
	border-radius: 2px;
	transition: all 0.3s cubic-bezier(.4, 2, .6, 1);
}

.buzz-burger.open span:nth-child(1) {
	transform: translateY(9px) rotate(45deg);
}

.buzz-burger.open span:nth-child(2) {
	opacity: 0;
}

.buzz-burger.open span:nth-child(3) {
	transform: translateY(-9px) rotate(-45deg);
}

.buzz-title {
	font-family: 'Montserrat', sans-serif !important;
	font-size: 22px !important;
	color: #1e293b !important;
	text-decoration: none;
	letter-spacing: -0.01em;
}

.buzz-nav-list {
	display: flex;
	align-items: center;
	gap: 14px;
	list-style: none;
	margin: 0;
	padding: 0;
}

.buzz-nav-item a {
	color: #475569;
	text-decoration: none;
	font-size: 0.9rem;
	font-family: 'Rubik', sans-serif !important;
	padding: 7px 10px;
	border-radius: 8px;
	transition: background 0.15s, color 0.15s;
	display: flex;
	align-items: center;
	gap: 6px;
}

.buzz-nav-item a:hover,
.buzz-nav-item a:active {
	background: #f1f5f9;
	color: #243654;
}

.buzz-bell-link i {
	font-size: 17px;
	margin: 0;
}

@media (max-width: 640px) {
	.buzz-title {
		font-size: 16px !important;
		text-align: center !important;
	}
}
</style>